/**
 * 데이터 기반 검색 분류표 (M3D) — docs/dv-search-tree-m3d.md 의 「제안」 열에서 생성(scratchpad gen_categories.py).
 * 키: 공정도 id. nodes: 노드명 → 분류, props: "노드명/속성명" → 분류(노드와 다를 때만), makers: 재료 노드 → 그것을 만든 공정 노드(공정 흐름표 편집값).
 * 분류 키: material 재료 / process 공정 / performance 성능 / analysis 분석 / etc 기본. "material:게이트절연막" 처럼 세분류 가능.
 * 표에 없는 노드·속성은 DvSearch 의 자동 규칙(태그 유형·이름·property_class)으로 폴백한다. 사용자가 문서를 고치면 이 파일을 다시 생성한다.
 */
export default {
  "8132": {
    "name": "n형 반도체",
    "nodes": {
      "Substrate": "material",
      "Thermal evaporation": "process",
      "Deposition (PECVD)": "process",
      "J-V": "analysis",
      "ALD": "process",
      "sputter deposition": "process",
      "CVD": "process",
      "Evaporation": "process",
      "spin coating": "process",
      "Annealing": "process",
      "electrical property": "analysis",
      "XPS": "analysis",
      "UPS": "analysis",
      "IPES": "analysis",
      "Deposition": "process",
      "TFT performance": "performance",
      "(기본 정보)": "etc"
    },
    "props": {
      "Thermal evaporation/materials": "material",
      "Deposition (PECVD)/material": "material",
      "J-V/gate leakage current": "performance",
      "ALD/material": "material",
      "ALD/Precursor name": "material",
      "ALD/reactant name": "material",
      "sputter deposition/target": "material",
      "CVD/precursor name": "material",
      "CVD/reactant name": "material",
      "spin coating/material": "material",
      "spin coating/precursor name": "material",
      "electrical property/Stage temperature": "performance",
      "electrical property/Sample thickness": "performance",
      "electrical property/Current": "performance",
      "electrical property/Carrier concentration": "performance",
      "electrical property/hole mobility": "performance",
      "electrical property/resistivity": "performance",
      "Deposition/material": "material"
    },
    "subcats": {},
    "makers": {}
  },
  "8262": {
    "name": "p형 반도체",
    "nodes": {
      "Substrate": "material",
      "Thermal evaporation": "process",
      "ALD": "process",
      "J-V": "analysis",
      "sputter deposition": "process",
      "CVD": "process",
      "Evaporation": "process",
      "spin coating": "process",
      "Annealing": "process",
      "electrical property": "analysis",
      "XPS": "analysis",
      "UPS": "analysis",
      "IPES": "analysis",
      "Deposition": "process",
      "TFT performance": "performance",
      "(기본 정보)": "etc"
    },
    "props": {
      "Thermal evaporation/materials": "material",
      "ALD/material": "material",
      "J-V/gate leakage current": "performance",
      "ALD/Precursor name": "material",
      "ALD/reactant name": "material",
      "sputter deposition/target": "material",
      "CVD/precursor name": "material",
      "CVD/reactant name": "material",
      "spin coating/material": "material",
      "spin coating/precursor name": "material",
      "electrical property/Stage temperature": "performance",
      "electrical property/Sample thickness": "performance",
      "electrical property/Current": "performance",
      "electrical property/Carrier concentration": "performance",
      "electrical property/hole mobility": "performance",
      "electrical property/resistivity": "performance",
      "Deposition/material": "material"
    },
    "subcats": {},
    "makers": {}
  },
  "8264": {
    "name": "적층소재",
    "nodes": {
      "Substrate": "material",
      "spin coating": "process",
      "ALD": "process",
      "sputter deposition": "process",
      "CVD": "process",
      "Evaporation": "process",
      "XRD": "analysis",
      "Device analysis": "performance",
      "(기본 정보)": "etc"
    },
    "props": {
      "spin coating/precursor name": "material",
      "ALD/material": "material",
      "ALD/precursor name": "material",
      "ALD/Precursor name": "material",
      "ALD/precursor3 name": "material",
      "ALD/reactant name": "material",
      "sputter deposition/target": "material",
      "CVD/precursor name": "material",
      "CVD/reactant name": "material"
    },
    "subcats": {},
    "makers": {}
  },
  "8267": {
    "name": "M3D 소자",
    "nodes": {
      "Substrate": "material",
      "Deposition": "process",
      "ALD": "process",
      "sputter deposition": "process",
      "n-type active layer": "material",
      "TFT performance": "performance",
      "planarization": "process",
      "Annealing": "process",
      "p-type active layer": "material",
      "inverter performance": "performance",
      "R/O performance": "performance",
      "(기본 정보)": "etc"
    },
    "props": {
      "Deposition/material": "material",
      "ALD/material": "material",
      "ALD/precursor name": "material",
      "ALD/reactant name": "material",
      "sputter deposition/target": "material",
      "planarization/Materials": "material"
    },
    "subcats": {},
    "makers": {}
  },
  "8265": {
    "name": "계산 데이터",
    "nodes": {
      "dielectric layer": "material",
      "(기본 정보)": "etc"
    },
    "props": {},
    "subcats": {},
    "makers": {}
  }
};
